import StepGroupsOrder from "./step_groups_order.coffee"

$(document).on 'turbolinks:load', ->
  new StepGroupsOrder().handler_events()